import React from 'react'
import { Dropdown, Space } from 'antd'
import { weekOptions, seasonOptions } from '../utils/nfl-week'
import { CaretDownOutlined } from '@ant-design/icons'
import styled from 'styled-components'

const DrowdownContainer = styled.div`
  display: inline-block;
`
const SmallCarrot = styled.span`
  font-size: 10px;
  margin-left: -5px;
`

const NFLWeekPicker = ({ selectedWeek, selectedSeason, changeDateInfo }) => {
  const _seasonOptions = seasonOptions.map(season => {
    return {
      label: <div onClick={() => {changeDateInfo({counter: selectedWeek, season})}}> {season} </div>,
      key: season
    }
  })
  const _weekOptions = weekOptions.map(week => {
    return {
      label: <div onClick={() => {changeDateInfo({counter: week, season: selectedSeason})}}> {week} </div>,
      key: week
    }
  })

  return (
    <DrowdownContainer>
      <Dropdown
        menu={{ items: _seasonOptions}}
        trigger={['click']}
      >
        <Space>
          {selectedSeason}<SmallCarrot><CaretDownOutlined /></SmallCarrot>
        </Space>
      </Dropdown>
      <span style={{ margin: '10px', fontSize: '14px'}} >Week</span>
      <Dropdown
        menu={{items: _weekOptions}}
        trigger={['click']}
        overlayStyle={{
          'max-height': '250px',
          'overflow': 'auto',
          'min-width': '100px'
        }}
      >
        <Space>
          {selectedWeek}<SmallCarrot><CaretDownOutlined /></SmallCarrot>
        </Space>
      </Dropdown>
    </DrowdownContainer>
  )
}

export default NFLWeekPicker
